// extracted by mini-css-extract-plugin
export default {"container":"QuantityControl_container__rqOfQ","btn":"QuantityControl_btn__tokjg","quantity":"QuantityControl_quantity__PcW1u"};